export class GovError extends Error {
	constructor(message: string) {
		super(message);
		this.name = 'GovError';
	}
}
